import React, { useState } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Grid, Container } from "semantic-ui-react";
import { CompanyModal } from "./CompanyModal";
import { useAuth } from "../../../AuthenticationStore";
import { Message } from "semantic-ui-react";

export const Companies = () => {
  const { companyService } = useAuth();
  const [modalCompany, setModalCompany] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [editData, setEditData] = useState();
  const [pageSize, setPageSize] = useState(0);
  const [page, setPage] = useState(5);

  const openModalCompany = () => {
    setEditData(undefined);
    setModalCompany(true);
  };

  const openModalEditCompany = data => {
    setEditData(data);
    setModalCompany(true);
  };

  const fetchData = async state => {
    setLoading(true);
    try {
      const result = await companyService.getCompanies(
        state.pageSize,
        state.page * state.pageSize
      );

      if (!result.result) {
        proccessError(result);
      }

      setData(result.object);
      // eslint-disable-next-line no-console
      console.log(result);
    } catch (error) {
      proccessError(error.response.data, true);
    }
    setLoading(false);
  };

  const proccessError = (cdResult, errorCath) => {
    const errorsArray = cdResult["cdExceptions"] || cdResult["CdExceptions"];
    let tempErrorsArray = [];

    for (let i = 0; i < errorsArray.length; i++) {
      const errorElement = errorsArray[i];
      tempErrorsArray.push(errorElement.exception || errorElement.Exception);
    }

    if (errorCath && tempErrorsArray.length === 0) {
      setErrors(["Error en el servidor"]);
    }

    setErrors(tempErrorsArray);
  };

  const disableCompany = async data => {
    setLoading(true);
    try {
      await companyService.disableCompany(data.companyId);
      fetchData({ page, pageSize });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setLoading(false);
  };

  const enableCompany = async data => {
    setLoading(true);
    try {
      await companyService.activateCompany(data.companyId);
      fetchData({ page, pageSize });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setLoading(false);
  };

  setTimeout(() => setLoading(false), 3000);

  const columns = [
    {
      Header: "Compañía",
      accessor: "companyName"
    },
    {
      Header: "Nombre Contacto",
      accessor: "contactName"
    },
    {
      Header: "Teléfono",
      accessor: "contactPhone",
      minWidth: 40
    },
    {
      Header: "Correo electrónico",
      accessor: "Correo electrónico",
      minWidth: 55
    },
    {
      Header: "Estado",
      accessor: d => {
        switch (d.state) {
          case 0:
            return "Activo";
          case 1:
            return "Inactivo";
          case 2:
            return "Beta";
          default:
            return "Sin estado";
        }
      },
      id: "state",
      minWidth: 35
    },
    {
      Cell: props => (
        <div className="btn-group" role="group" aria-label="">
          <button
            className="btn btn-primary"
            onClick={() => openModalEditCompany(props.original)}
          >
            <i className="mdi mdi-border-color"></i>
          </button>
          {props.original.state === 0 ? (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => disableCompany(props.original)}
            >
              <i className="mdi mdi mdi-eye-off"></i>
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => enableCompany(props.original)}
            >
              <i className="mdi mdi mdi-eye"></i>
            </button>
          )}
        </div>
      ),
      Header: "Acciones",
      accessor: "CompaniaId",
      minWidth: 50
    }
  ];

  return (
    <Container>
      <Grid>
        <CompanyModal
          show={modalCompany}
          handleClose={() => {
            setModalCompany(false);
            fetchData({ page, pageSize });
          }}
          data={editData}
        />
        {errors.length > 0 ? (
          <Grid.Row>
            <Grid.Column>
              <Message error>
                <Message.Header>Errores</Message.Header>
                <Message.List items={errors} />
              </Message>
            </Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row>
          <Grid.Column floated="right">
            <button
              className="btn btn-primary btn-icon-text"
              onClick={openModalCompany}
            >
              <i className="mdi mdi mdi-plus btn-icon-prepend"></i>
              Agregar compañía
            </button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              ref={instance => {
                if (!instance) return;
                setPageSize(instance.state.pageSize);
                setPage(instance.state.page);
              }}
              manual
              defaultPageSize={10}
              data={data}
              onFetchData={fetchData}
              loading={loading}
              minRows={1}
              columns={columns}
              previousText="Anterior"
              nextText="Siguiente"
              pageText="página"
              ofText="de"
              rowsText="registros"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};
